import { ipezbyApi } from './client';
import type {
  ClientIpResponse,
  WhoisResponse,
  DnsResponse,
  DnsRecordType,
} from './types';

const ENDPOINT = '/ipezby_api.php';

export const ipezbyApiMethods = {
  /**
   * Получить IP клиента и провайдера (без авторизации)
   */
  getClientIp: async (): Promise<ClientIpResponse> => {
    const { data } = await ipezbyApi.get<ClientIpResponse>(
      `${ENDPOINT}?action=getClientIp`
    );
    return data;
  },

  /**
   * Получить WHOIS информацию
   */
  getWhois: async (host: string): Promise<WhoisResponse> => {
    const { data } = await ipezbyApi.post<WhoisResponse>(
      ENDPOINT,
      { action: 'getWhoisInfo', host },
      { headers: { 'Content-Type': 'application/json' } }
    );
    return data;
  },

  /**
   * Получить DNS записи (для доменов)
   */
  getDns: async (host: string, type: DnsRecordType): Promise<DnsResponse> => {
    const { data } = await ipezbyApi.post<DnsResponse>(
      ENDPOINT,
      { action: 'getDnsInfo', host, type },
      { headers: { 'Content-Type': 'application/json' } }
    );
    return data;
  },

  /**
   * Получить PTR записи (для IP адресов)
   */
  getPtr: async (host: string): Promise<DnsResponse> => {
    const { data } = await ipezbyApi.post<DnsResponse>(
      ENDPOINT,
      { action: 'getPtrInfo', host },
      { headers: { 'Content-Type': 'application/json' } }
    );
    return data;
  },
};
